var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { Job } from 'packages/jobs/entities/Job';
var JobRepository = /** @class */ (function (_super) {
    __extends(JobRepository, _super);
    function JobRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.entity = Job;
        _this.url = 'api/v2/jobs';
        return _this;
    }
    JobRepository.prototype.listByIds = function (ids) {
        return this.getPaginated("" + this.url, null, {
            per_page: 100,
            filters: { ids: ids },
        });
    };
    JobRepository.prototype.listActiveByCompanyId = function (companyId) {
        return this.getAll("" + this.url, null, {
            per_page: 100,
            filters: {
                company_id: companyId,
                statuses: [
                    'active',
                ],
            },
            sort: {
                field: 'updated_at',
                direction: 'desc',
            },
        });
    };
    return JobRepository;
}(AbstractRepository));
export { JobRepository };
